export default __webpack_public_path__ + "static/media/achievement_discover_more_books.f41ea772.mp3";